import client from '../apiClient';

export async function getBodyConditions() {
    let response = await client.get(`/bodyCondition`);
    return response.data;
}
